const browserExtensionPattern = /(?:chrome|moz|safari-web)-extension:\/\/|lastpass/i;
const developmentServerPattern = /webpack-dev-server|webpack\/hot|sockjs-node|\/__webpack_hmr|localhost:\d+\/ws(?:[/?#]|$)/i;

const getEventText = (event: any, hint?: any): string[] => {
  const exceptionValues = event?.exception?.values ?? [];
  const frames = exceptionValues.flatMap((value: any) => value?.stacktrace?.frames ?? []);
  const originalException = hint?.originalException;

  return [
    event?.message,
    event?.transaction,
    event?.request?.url,
    ...exceptionValues.flatMap((value: any) => [value?.type, value?.value]),
    ...frames.flatMap((frame: any) => [frame?.filename, frame?.module]),
    originalException?.message,
    originalException?.stack,
  ].filter((value): value is string => typeof value === "string");
};

export const isLocalSentryNoise = (event: any, hint?: any): boolean =>
  getEventText(event, hint).some(value =>
    browserExtensionPattern.test(value) || developmentServerPattern.test(value)
  );

export const isLocalSentryBreadcrumbNoise = (breadcrumb: any): boolean => {
  const values = [breadcrumb?.message, breadcrumb?.data?.url]
    .filter((value): value is string => typeof value === "string");

  return values.some(value =>
    browserExtensionPattern.test(value) || developmentServerPattern.test(value)
  );
};
